import { AppError } from './AppError';

/**
 * Represents an error for when a requested resource is not found.
 * Corresponds to an HTTP 404 Not Found status.
 */
export class NotFoundError extends AppError {
  constructor(message: string = 'Resource not found', details?: any, options?: ErrorOptions) {
    super(message, 404, details, options);
  }
}
